import { useState } from "react";
import PanelItem from "./PanelItem";
import SelectedWaterSystemHeader from "../reuseableComponents/SelectedWaterSystemHeader";

const SidePanel = (props) => {
  const [panelState, setPanelState] = useState("expanded");
  const { menuItems, selectedWaterSystem } = props;

  const links = [];
  if (menuItems && Array.isArray(menuItems)) {
    menuItems.forEach((item) => {
      if (item.code && item.label) {
        if (item.url_route) {
          links.push({
            type: "link",
            title: item.label,
            url: item.url_route,
            external: item.url_route.includes("/v1/"),
          });
        } else {
          links.push({
            type: "heading",
            title: item.label
          });
        }
      }
    });
  }
  
  return (
    <>
    {/* <div style={{transition: "width 0.3s ease-in-out", display: "flex", flexDirection: "column", maxHeight: "100%"}} className={panelState}> */}
        
           
                <SelectedWaterSystemHeader selectedWaterSystem={selectedWaterSystem} />
                <div className="panel-links" style={{overflowY: "auto", scrollbarWidth: "thin"}}>
                  {links.map((link, idx) => (
                    link.type === "heading" ? (
                      <div key={"heading-" + idx} className="sidepanel-section-heading" style={{fontWeight: "bold", margin: "12px 0 4px 0"}}>
                        {link.title}
                      </div>
                    ) : (
                      <PanelItem 
                        key={link.title} 
                        title={link.title} 
                        panelState={panelState} 
                        url={link.url}
                        external={link.external}
                        onchange={setPanelState}
                      />
                    )
                  ))}
                </div>
    {/* </div> */}
    </>
  );
};

export default SidePanel;
